import { Component, OnDestroy, OnInit } from "@angular/core";
import {
  NbDialogService,
  NbMediaBreakpointsService,
  NbMenuService,
  NbSidebarService,
  NbThemeService,
  NbWindowService,
} from "@nebular/theme";

import { LayoutService } from "../../../@core/utils";
import { map, takeUntil } from "rxjs/operators";
import { Observable, Subject } from "rxjs";
import { UserService } from "../../../@core/services/user.service";
import { Router } from "@angular/router";

import { ProfileService } from "../../../services/profile.service";

import { UserData } from "../../../@core/data/users";
import { TranslateService } from "@ngx-translate/core";
import { DialogNotificationsComponent } from "../../../@components/dialog-notifications/dialog-notifications.component";
import Shop from "../../../models/shop.model";
import { ShopService } from "../../../services/shop.service";
import { DialogRegisterComponent } from "../../../@components/dialogs/dialog-register/dialog-register.component";
import { WindowGuideComponent } from "../../../@components/windows/window-guide/window-guide.component";

@Component({
  selector: "ngx-header",
  styleUrls: ["./header.component.scss"],
  templateUrl: "./header.component.html",
})
export class HeaderComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  userPictureOnly: boolean = false;
  user: any;
  userData: UserData = new UserData();
  uid = "";

  themes = [
    {
      value: "default",
      name: "Light",
    },
    {
      value: "dark",
      name: "Dark",
    },
    {
      value: "cosmic",
      name: "Cosmic",
    },
    {
      value: "corporate",
      name: "Corporate",
    },
  ];

  currentTheme = "default";

  userMenu = [
    { title: "Profile", link: "/profile" },
    { title: "Log out", link: "/auth/logout" },
  ];

  languages = [
    {
      value: "vn",
      name: "Vietnam",
    },
    {
      value: "en",
      name: "English",
    },
    {
      value: "km",
      name: "Khmer",
    },
  ];
  currentLanguage = "vn";
  shop: Shop = new Shop();
  isMobile = false;

  constructor(
    private sidebarService: NbSidebarService,
    private menuService: NbMenuService,
    private themeService: NbThemeService,
    public userService: UserService,
    private shopService: ShopService,
    private layoutService: LayoutService,
    private breakpointService: NbMediaBreakpointsService,
    protected router: Router,
    private dialogService: NbDialogService,
    private windowService: NbWindowService,
    private translate: TranslateService
  ) {
    translate.addLangs(["en", "vn"]);
    translate.setDefaultLang(this.currentLanguage);
  }

  ngOnInit() {
    this.currentTheme = this.themeService.currentTheme;
    this.userData.notifications = 0;

    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: any) => {
        if (user && user.uid != this.uid) {
          this.user = user;
          this.getShop(this.user.shopId);

          this.translate.use(this.user.language);

          this.userService
            .get(user.uid)
            .pipe(takeUntil(this.destroy$))
            .subscribe((data) => {
              this.userData = data;
              // console.log("header/userData:", this.userData);
            });
        } else {
          this.uid = "";
        }
      });

    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService
      .onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$)
      )
      .subscribe(
        (isLessThanXl: boolean) => (this.userPictureOnly = isLessThanXl)
      );

    this.themeService
      .onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$)
      )
      .subscribe((themeName) => (this.currentTheme = themeName));

    //process auto collapse menu sidebar
    const { sm } = this.breakpointService.getBreakpointsMap();
    this.menuService
      .onItemSelect()
      .pipe(takeUntil(this.destroy$))
      .subscribe((event: { tag: string; item: any }) => {
        if (document.documentElement.clientWidth < sm) {
          this.sidebarService.collapse("menu-sidebar");
        }
      });

    this.themeService
      .onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < sm),
        takeUntil(this.destroy$)
      )
      .subscribe((isLessThanSm: boolean) => {
        this.isMobile = isLessThanSm;
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  switchLanguage(lang: string) {
    console.log("switchLanguage:", lang);
    this.translate.use(lang);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, "menu-sidebar");
    this.layoutService.changeLayoutSize();

    return false;
  }

  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }

  private getShop(shopId) {
    this.shopService
      .get(shopId)
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        this.shop = res;
      });
  }

  login() {
    this.router.navigateByUrl(`/auth/login`);

    // this.dialogService
    //   .open(DialogAuthLoginComponent, {
    //     context: {
    //       mode: "header",
    //     },
    //     closeOnBackdropClick: false,
    //   })
    //   .onClose.subscribe((value) => {
    //     if (value) {
    //       console.log("HeaderComponent/login:", value);
    //       this.user = value;
    //     }
    //   });
  }

  feedback() {
    // let fbNew = new Feedback();
    // fbNew.category = "Góp ý";
    // this.dialogService
    //   .open(DialogFeedbackComponent, {
    //     context: {
    //       header: "Tạo góp ý / báo lỗi",
    //       mode: "new",
    //       feedback: fbNew,
    //     },
    //     closeOnBackdropClick: false,
    //   })
    //   .onClose.subscribe((value) => {
    //     this.router.navigateByUrl("/develop/feedback");
    //   });
  }

  register() {
    this.dialogService
      .open(DialogRegisterComponent, {
        context: {},
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value) => {
        if (value) {
          console.log("HeaderComponent/DialogRegisterComponent:", value);
        }
      });
  }

  notifications() {
    this.dialogService.open(DialogNotificationsComponent, {
      context: {},
      // hasBackdrop: false,
      // closeOnBackdropClick: false,
    });
  }

  showGuid() {
    this.windowService.open(WindowGuideComponent, {
      title: "Hướng dẫn sử dụng phần mềm",
      context: { text: "some text to pass into template" },
      hasBackdrop: true,
      closeOnEsc: true,
    });
  }
}
